var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from "react";
import styled from "@mui/system/styled";
import useTheme from "@mui/system/useTheme";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { PopperComponent } from "../Popper";
import config from "../../assests/config";
import LogoImage from "../../assests/images/netwell-logo.png";
const HeaderWrapper = styled("header")(({ theme }) => {
    return {
        height: 80,
        position: "sticky",
        top: 0,
        zIndex: 4,
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        padding: "10px",
        width: "100%",
        ".headerMain": {
            paddingLeft: 3,
            paddingRight: 10,
            display: "flex",
            flex: 1,
            position: "sticky",
            "&>.MuiButtonBase-root": {
                paddingLeft: 7,
                paddingBottom: 7,
            }
        },
        ".header_middle-section": {
            flex: 6,
            alignItems: "center",
            display: "flex",
            color: "#000",
            fontSize: 20,
            fontweight: 500,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.6,
            letterSpacing: 0.5,
            width: 108,
            img: {
                objectFit: "contain",
                height: 45,
            },
        },
        ".header_right-section": {
            flex: 3,
            textAlign: "end",
            display: "contents",
            justifyContent: "end",
            marginRight: 10,
            alignItems: "center",
            ".header_right-icon": {
                alignSelf: "center",
                width: 24,
            },
        },
        ".tabheader": {
            height: 48,
            boxShadow: "0px 1px 0px 0 rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 12%), 1px 4px 4px 0 rgb(0 0 0 / 14%)",
        },
        // Responsive
        [theme.breakpoints.down(768)]: {
            boxShadow: " 0 2px 4px 0 rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
            ".header_middle-page_name_text": {
                display: "block",
            },
            ".headerMain": {
                zIndex: 0,
            },
        },
    };
});
export const Header = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { style } = props, rest = __rest(props, ["style"]);
    const theme = useTheme();
    const showText = useMediaQuery(theme.breakpoints.up("md"));
    const [state, setState] = React.useState(false);
    const [click, setClick] = React.useState(false);
    const [pageName] = React.useState((_b = (_a = props.sideBarData) === null || _a === void 0 ? void 0 : _a.selectedItem) === null || _b === void 0 ? void 0 : _b.pageName);
    const [selectedIndex, setSelectedIndex] = React.useState((_d = (_c = props.sideBarData) === null || _c === void 0 ? void 0 : _c.selectedItem) === null || _d === void 0 ? void 0 : _d.selectedIndex);
    const [headerHeight, setHeaderHeight] = React.useState(0);
    const ref = React.useRef(null);
    const DrawerRef = React.useRef(null);
    useOutsideAlerter(DrawerRef);
    React.useLayoutEffect(() => {
        var _a;
        setHeaderHeight((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
    }, []);
    const handleListItemClick = (index, value) => {
        var _a, _b, _c, _d;
        if ((_b = (_a = props.sideBarData) === null || _a === void 0 ? void 0 : _a.selectedItem) === null || _b === void 0 ? void 0 : _b.selectedIndex)
            setSelectedIndex(index);
        // setPageName(value);
        (_d = (_c = props.sideBarData) === null || _c === void 0 ? void 0 : _c.sideBarCallBack) === null || _d === void 0 ? void 0 : _d.call(_c, { index });
        setState(false);
    };
    const handleRightClick = (event) => {
        var _a, _b, _c;
        const icon = (_b = (_a = props.rightSectionIconList) === null || _a === void 0 ? void 0 : _a.Iconlist) === null || _b === void 0 ? void 0 : _b.find(({ alt }) => alt === event.target.alt);
        !(icon === null || icon === void 0 ? void 0 : icon.Component) && ((_c = props.rightSectionIconList) === null || _c === void 0 ? void 0 : _c.rightCallBack({ icon }));
    };
    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setClick(true);
                    setState(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    return (React.createElement(HeaderWrapper, Object.assign({ style: props.style }, rest, { ref: ref }), props.variant === "web" ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "headerMain" },
            React.createElement(IconButton, { onClick: () => (!click ? setState(true) : setClick(false)), disableRipple: true },
                React.createElement(MenuIcon, null)),
            React.createElement("div", { className: "header_middle-section", style: props.middleSectionStyle }, showText ? (React.createElement("img", { style: props.logoImageStyle, src: props === null || props === void 0 ? void 0 : props.logoImage, alt: "icon" })) : (React.createElement("span", { className: "header_middle-page_name_text" }, pageName))),
            React.createElement("div", { className: "header_right-section", onClick: handleRightClick, style: props.rightSectionStyle },
                React.createElement(PopperComponent, { list: (_e = props.rightSectionIconList) === null || _e === void 0 ? void 0 : _e.Iconlist, callback: (_f = props.rightSectionIconList) === null || _f === void 0 ? void 0 : _f.rightCallBack }))),
        React.createElement(Drawer, { ref: DrawerRef, anchor: "left", open: state, onClose: () => setState(false), PaperProps: {
                sx: props.listOfSideBarStyle,
            }, transitionDuration: { enter: 400, exit: 400 }, style: showText
                ? {
                    zIndex: 0,
                }
                : {} },
            React.createElement(Box, { sx: {
                    overflow: "hidden",
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                        width: 9,
                    },
                    // "&::-webkit-scrollbar-track": {
                    //   boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                    // },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "darkgrey",
                    },
                } },
                React.createElement(List, { sx: Object.assign({}, (((_g = props.listOfSideBarStyle) === null || _g === void 0 ? void 0 : _g.StyledList) || {})), style: showText ? { marginTop: headerHeight } : {} },
                    !showText && (React.createElement(ListItem, { sx: {
                            maxWidth: "180px",
                        } },
                        React.createElement("img", { className: "mob_view_logo_img", src: ((_h = props === null || props === void 0 ? void 0 : props.sideBarData) === null || _h === void 0 ? void 0 : _h.logoImage) || LogoImage, alt: "icon", width: "100%" }))),
                    React.createElement(ListItem, null,
                        React.createElement(ListItemIcon, { style: { minWidth: "32px" } },
                            React.createElement(AccountCircleIcon, { sx: { color: "black" } })),
                        React.createElement(ListItemText, { sx: Object.assign({ ".MuiListItemText-root": {
                                    width: showText ? '148px' : '202px'
                                } }, (_j = props.listOfSideBarStyle) === null || _j === void 0 ? void 0 : _j.listItemText), disableTypography: true, primary: config.text.HELLO + props.user })), (_l = (_k = props.sideBarData) === null || _k === void 0 ? void 0 : _k.listOfSideBar) === null || _l === void 0 ? void 0 :
                    _l.map((key, index) => {
                        var _a;
                        return (React.createElement(ListItem, { key: index, disablePadding: true },
                            React.createElement(ListItemButton, { selected: selectedIndex === index, onClick: () => handleListItemClick(index, key.text) },
                                React.createElement(ListItemIcon, null,
                                    React.createElement("img", { src: key.icon, width: "22px", alt: key.text })),
                                React.createElement(ListItemText, { sx: (_a = props.listOfSideBarStyle) === null || _a === void 0 ? void 0 : _a.listItemText, disableTypography: true, primary: key.text }))));
                    }),
                    !showText && (React.createElement(ListItem, null,
                        React.createElement(ListItemText, null, props.Version)))))))) : (React.createElement(React.Fragment, null, props.MobileViewComponant && React.createElement(props.MobileViewComponant, null)))));
};
